"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/stream/v1/internal_service.proto (package spwn.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalStreamService = void 0;
const internal_service_pb_1 = require("./internal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.stream.v1.InternalStreamService
 */
exports.InternalStreamService = {
    typeName: "spwn.stream.v1.InternalStreamService",
    methods: {
        /**
         * 配信ビデオを作成する
         *
         * @generated from rpc spwn.stream.v1.InternalStreamService.CreateStreamingVideo
         */
        createStreamingVideo: {
            name: "CreateStreamingVideo",
            I: internal_service_pb_1.InternalStreamServiceCreateStreamingVideoRequest,
            O: internal_service_pb_1.InternalStreamServiceCreateStreamingVideoResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 指定したイベントの配信ビデオすべてを取得する
         *
         * @generated from rpc spwn.stream.v1.InternalStreamService.GetAllStreamingVideosByEventId
         */
        getAllStreamingVideosByEventId: {
            name: "GetAllStreamingVideosByEventId",
            I: internal_service_pb_1.InternalStreamServiceGetAllStreamingVideosByEventIdRequest,
            O: internal_service_pb_1.InternalStreamServiceGetAllStreamingVideosByEventIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * ticketをもとにstreamingを構成し直す
         *
         * @generated from rpc spwn.stream.v1.InternalStreamService.ReconfigureStreamingByTickets
         */
        reconfigureStreamingByTickets: {
            name: "ReconfigureStreamingByTickets",
            I: internal_service_pb_1.InternalStreamServiceReconfigureStreamingByTicketsRequest,
            O: internal_service_pb_1.InternalStreamServiceReconfigureStreamingByTicketsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=internal_service_connect.js.map